/* eslint-disable react/prop-types */
import axios from 'axios';
import Cookies from 'js-cookie';
import { debounce } from 'lodash';
// import Select from 'react-select';
import { FieldArray } from 'formik';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useState } from 'react';
// api
import ApiKey from '../../../api/ApiKey';
import BaseApi from '../../../api/BaseApi';
import { getCities } from '../../../employersSide/api/getCities';
import { getSubCategories } from '../../../employersSide/api/getSubCategories';
// components
import Input from '../../components/Input';
import SelectReact from '../../components/SelectReact';
import AsyncSelectReact from '../../components/AsyncSelectReact';
import SelectWithIdInOptions from '../../components/SelectWithIdInOptions';
import AutocompleteCreatableAsync from '../../components/AutocompleteCreatableAsync';
// helpers
import { debounceAsync } from '../../../helpers';
// hooks
import { useWindowSize } from '../../../../Hooks/use-window-size';

const getNameFromArray = (id, array) => {
  const item = array.find(item => item.id == id);

  return item ? { label: item.name, value: item.id } : undefined;
};

const convertObjectToArrayOfObjects = obj => Object.entries(obj).map(([key, value]) => ({
  id: key,
  name: value,
}));

const DesiredPositionBlock = ({ errors, values, touched, directories, handleChange, setFieldValue, setFieldTouched }) => {
  const { width } = useWindowSize();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');

  const { work_types = [], countries = [], categories = [], currencies = [], sub_categories = [] } = directories;

  const {
    position = '',
    work_type = '',
    salary_max = '',
    salary_min = '',
    relocations = [],
    desired_country = '',
    salary_currency = '',
    desired_category = [],
  } = values;

  // const [prevPosition, setPrevPosition] = useState('');
  const [salaryMax, setSalaryMax] = useState(salary_max || '');
  const [salaryMin, setSalaryMin] = useState(salary_min || '');
  const [subCategories, setSubCategories] = useState(sub_categories || []);

  const getPositionOptions = async inputValue => {
    if (inputValue.length < 2) {
      return [];
    }

    try {
      const positions = await axios.post(
        BaseApi + '/candidates/getPositions',
        { query: inputValue },
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      const options = positions.data.response.map(position => ({
        value: position.id,
        label: position.name,
      }));

      return [
        ...options,
        { value: inputValue, label: inputValue },
      ];
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [{ value: inputValue, label: inputValue }];
    }
  };

  const getSubCategoriesOptions = async (id, index) => {
    if (!id) {
      setSubCategories(prevState => {
        const newSubCategory = [...prevState];
        newSubCategory[index] = [];

        return newSubCategory;
      });

      return;
    }

    setSubCategories(prevState => {
      const newSubCategory = [...prevState];
      newSubCategory[index] = [];

      return newSubCategory;
    });

    try {
      const subCategories = await getSubCategories(id);

      const options = subCategories.data.response.map(position => ({
        value: position.id,
        label: position.name,
      }));

      setSubCategories(prevState => {
        const newSubCategories = [...prevState];
        newSubCategories[index] = options;

        return newSubCategories;
      });
    } catch (error) {
      console.error('Couldn\'t get Sub category data!', error);
    }
  };

  const getCitiesOptions = async inputValue => {
    if (!desired_country || inputValue.length < 2) {
      return [];
    }

    try {
      const cities = await getCities(parseInt(desired_country), inputValue);

      if (cities.data.response?.length === 0) {
        throw new Error('No options found');
      }

      const options = cities.data.response.map(city => ({
        value: city.id,
        label: `${city.name}${city.region && `, ${city.region}`}`,
      }));

      return options;
    } catch (error) {
      console.error('Error fetching cities:', error);

      return [];
    }
  };

  // const handleFocus = async position => {
  //   setPrevPosition(position);
  //   await setFieldValue('position', '');
  //   await setFieldError('position', '');
  // };

  // const handleBlur = async position => {
  //   if (!position) {
  //     await setFieldValue('position', prevPosition);

  //     if (prevPosition !== '') {
  //       const currentErrors = { ...errors };

  //       delete currentErrors.position;

  //       await setErrors(currentErrors);
  //     }
  //   }
  // };

  const handleInputChange = useCallback(e => {
    const { name, value } = e.target;

    if (name === 'salary_max') {
      setSalaryMax(value);
    } else {
      setSalaryMin(value);
    }

    debouncedHandleInputChange(name, value);
  }, []); // eslint-disable-line

  const handleFieldChange = (field, selectedOptions, limit = null) => {
    if (limit && selectedOptions.length > limit) {
      return;
    }

    if (selectedOptions) {
      if (field === 'desired_country') {
        setFieldValue(field, selectedOptions.value);
      } else {
        setFieldValue(field, selectedOptions);
      }
    } else {
      setFieldValue(field, '');
    }
  };

  const handleSubCategoryChange = (selectedOptions, index) => {
    if (selectedOptions.length > 2) {
      return;
    }

    setFieldValue(`desired_category[${index}].sub_category`, selectedOptions);
  };

  const handleRemoveDesiredCategory = (index, remove) => {
    remove(index);

    setSubCategories(prevState => prevState.filter((_, i) => i !== index));
  };

  const debouncedGetCitiesOptions = debounceAsync(getCitiesOptions, 500);
  const debouncedGetPositionOptions = debounceAsync(getPositionOptions, 500);

  const debouncedHandleInputChange = debounce((name, value) => {
    setFieldValue(name, value);
  }, 500);

  useEffect(() => {
    // if (width >= 768) {
    //   window.scrollTo({ top: 350, behavior: 'smooth' });
    // } else {
    //   window.scrollTo({ top: 650, behavior: 'smooth' });
    // }
  }, [width]);

  return (
    <>
      <AutocompleteCreatableAsync
        required
        name='position'
        value={position}
        error={errors.position}
        touched={touched.position}
        loadOptions={debouncedGetPositionOptions}
        label={t('jobseekerEditProfile.desiredPosition')}
        placeholder={t('jobseekerEditProfile.enterPosition')}
        loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
        handleChange={selectedOption => handleFieldChange('position', selectedOption)}
        noOptionsMessage={({ inputValue }) =>
          inputValue.length >= 2
            ? t('jobseekerEditProfile.noOptionsFound')
            : t('jobseekerEditProfile.enterPosition')
        }
        handleFocus={() => {
          // handleFocus(position);
        }}
        handleBlur={() => {
          setTimeout(() => {
            setFieldTouched('position', true);
          }, 200);
        }}
      />
      <div className='mt-4 mb-4'>
        <FieldArray
          name='desired_category'
          render={({ push, remove }) => (
            desired_category.map((i, index) => (
              <div key={index} className={index !== desired_category?.length - 1 ? 'mb-4' : ''}>
                <SelectReact
                  required
                  isClearable
                  isSearchable
                  label={t('jobseekerEditProfile.category')}
                  name={`desired_category[${index}].category`}
                  error={errors?.desired_category?.[index]?.category}
                  placeholder={t('jobseekerEditProfile.selectCategory')}
                  touched={touched?.desired_category?.[index]?.category}
                  value={getNameFromArray(i.category, categories) || i.category}
                  options={categories.map(i => ({ value: i.id, label: i.name }))}
                  noOptionsMessage={() => t('jobseekerEditProfile.noOptionsFound')}
                  handleBlur={() => setFieldTouched(`desired_category[${index}].category`, true)}
                  handleChange={selectedOptions => {
                    handleFieldChange(`desired_category[${index}].category`, selectedOptions);
                    getSubCategoriesOptions(selectedOptions?.value, index);
                    setFieldValue(`desired_category[${index}].sub_category`, []);
                  }}
                />
                <SelectReact
                  isMulti
                  required
                  isSearchable
                  value={i.sub_category}
                  label={t('jobseekerEditProfile.subCategory')}
                  options={subCategories[index]?.map(i => (i))}
                  name={`desired_category[${index}].sub_category`}
                  error={errors?.desired_category?.[index]?.sub_category}
                  placeholder={t('jobseekerEditProfile.selectSubCategory')}
                  touched={touched?.desired_category?.[index]?.sub_category}
                  handleChange={selectedOptions => handleSubCategoryChange(selectedOptions, index)}
                  handleBlur={() => setFieldTouched(`desired_category[${index}].sub_category`, true)}
                  noOptionsMessage={
                    () => i.category
                      ? t('jobseekerEditProfile.noOptionsFound')
                      : t('jobseekerEditProfile.selectCategoryFirst')
                  }
                />
                <div className='row'>
                  <div className='removeButtonJobseeker'>
                    <button
                      type='button'
                      className='btn btn-primary button2'
                      disabled={desired_category.length === 1}
                      onClick={() => handleRemoveDesiredCategory(index, remove)}
                    >
                      {t('jobseekerEditProfile.removeButton')}
                    </button>
                    {
                      index === desired_category.length - 1 && (
                        <button
                          type='button'
                          className='btn btn-primary button1'
                          disabled={desired_category.length > 2}
                          onClick={() => push({ category: '', sub_category: [] })}
                        >
                          {t('jobseekerEditProfile.addMoreButton')}
                        </button>
                      )
                    }
                  </div>
                </div>
              </div>
            ))
          )}
        />
      </div>
      <SelectReact
        required
        isClearable
        isSearchable
        name='desired_country'
        error={errors.desired_country}
        touched={touched.desired_country}
        label={t('jobseekerEditProfile.desiredCountry')}
        value={getNameFromArray(desired_country, countries)}
        placeholder={t('jobseekerEditProfile.selectCountry')}
        handleBlur={() => setFieldTouched('desired_country', true)}
        options={countries.map(i => ({ value: i.id, label: i.name }))}
        noOptionsMessage={() => t('jobseekerEditProfile.noOptionsFound')}
        handleChange={selectedOptions => {
          handleFieldChange('desired_country', selectedOptions);
          setFieldValue('relocations', []);
        }}
      />
      {
        desired_country && (
          <AsyncSelectReact
            isMulti
            required
            name='relocations'
            value={relocations}
            error={errors.relocations}
            touched={touched.relocations}
            loadOptions={debouncedGetCitiesOptions}
            label={t('jobseekerEditProfile.relocations')}
            placeholder={t('jobseekerEditProfile.enterCityName')}
            handleChange={selectedOptions => handleFieldChange('relocations', selectedOptions, 5)}
            loadingMessage={() => t('jobseekerEditProfile.pleaseWait')}
            noOptionsMessage={
              ({ inputValue }) => inputValue.length >= 2
                ? t('jobseekerEditProfile.noOptionsFound')
                : t('jobseekerEditProfile.enterCityName')
            }
            handleBlur={() => {
              setTimeout(() => {
                setFieldTouched('relocations', true);
              }, 200);
            }}
          />
        )
      }
      <div className='row'>
        <Input
          name='salary_min'
          value={salaryMin}
          className='col-lg-4'
          error={errors.salary_min}
          touched={touched.salary_min}
          errorMessage={errors.salary_min}
          handleChange={e => handleInputChange(e)}
          placeholder={t('jobseekerEditProfile.from')}
          label={t('jobseekerEditProfile.expectedSalaryFrom')}
          handleBlur={() => setFieldTouched('salary_min', true)}
        />
        <Input
          name='salary_max'
          value={salaryMax}
          className='col-lg-4'
          error={errors.salary_max}
          touched={touched.salary_max}
          errorMessage={errors.salary_max}
          handleChange={e => handleInputChange(e)}
          placeholder={t('jobseekerEditProfile.to')}
          label={t('jobseekerEditProfile.expectedSalaryTo')}
          handleBlur={() => setFieldTouched('salary_max', true)}
        />
        <SelectWithIdInOptions
          name='salary_currency'
          value={salary_currency}
          handleChange={handleChange}
          error={errors.salary_currency}
          touched={touched.salary_currency}
          className='col-lg-4 selectCurrency'
          required={salary_min || salary_max}
          errorMessage={errors.salary_currency}
          label={t('jobseekerEditProfile.selectCurrency')}
          options={convertObjectToArrayOfObjects(currencies)}
          defaultOption={t('jobseekerEditProfile.selectCurrency')}
          handleBlur={() => setFieldTouched('salary_currency', true)}
        />
      </div>
      <SelectReact
        isMulti
        required
        isSearchable
        className='mb-5'
        name='work_type'
        value={work_type}
        error={errors.work_type}
        touched={touched.work_type}
        label={t('jobseekerEditProfile.workType')}
        options={Object.entries(work_types).map(([key, value]) => ({ value: key, label: value }))}
        placeholder={t('jobseekerEditProfile.selectWorkType')}
        handleChange={selectedOptions => handleFieldChange('work_type', selectedOptions)}
        noOptionsMessage={() => t('jobseekerEditProfile.noOptionsFound')}
        handleBlur={() => {
          setTimeout(() => {
            setFieldTouched('work_type', true);
          }, 200);
        }}
      />
    </>
  );
};

export default DesiredPositionBlock;
